export class Tutorial {
    // tslint:disable-next-line: variable-name
    _id: string;
    nomeTutorial: string;
    passos: TutorialPasso[];
}

export class TutorialPasso {
    nomepasso: string;
    headerModal: string;
    textoModal: string;
    ordemAtividade: number;
    idBotaoAcao: number;
    passoIndividual: boolean;
}

export class TutorialProgresso {
    idCedente: string;
    idGestor: string;
    idTutorial: string;
    ordemAtividade: number;
    ativo: boolean;
    progresso: number;
    nomeTutorial: string;
}


